import React from 'react'

import { PSmaller } from '../Typography'

export const Source: React.FC<{ content: string }> = ({ content }) => {
  return <PSmaller color={60}>{content}</PSmaller>
}
